import styled from "styled-components";
import Button from "./Button";
import {device} from "../../theme";

const LetterButton = styled(Button)`
    background: ${(props) => props?.active ? "rgba(54,80,28,1)" : "rgba(54,80,28,0.2)"};
    color: ${(props) => props?.active ? props.theme.color.secondary.xxlight : props.theme.color.secondary.xxlight};
  
    &:hover {
        background-color: ${(props) => props.theme.color.secondary.base};
        color: ${(props) => props.theme.color.secondary.xxlight};
    }

  @media ${device.mobile} {
    padding: 4px 10px;
  }
`;

export default LetterButton;
